import { useMutation, useQuery } from "@apollo/client";
import { toaster } from "evergreen-ui";
import { auth } from "firebase";
import React, { useState } from "react";
import { UPDATE_USER_PROFILE } from "src/Mutations/Users.share";
import { CHECK_BY_USERNAME } from "src/Queries/users.shared";
import { InputHooksType } from "src/Types/data-types";
import SetupUsernamePresenter from "./SetupUsernamePresenter";

interface IProps {
  username: InputHooksType;
  name: InputHooksType;
  country: any;
  refetch: any;
}
const SetupUsername: React.SFC<IProps> = ({
  name,
  username,
  refetch,
  country,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { data, loading } = useQuery(CHECK_BY_USERNAME, {
    variables: {
      username: username.value,
    },
  });

  const [updateUser] = useMutation(UPDATE_USER_PROFILE);
  const onSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    updateUser({
      variables: {
        id: auth().currentUser?.uid,
        object: {
          username: username.value,
          name: name.value,
          country: country.length > 1 ? null : country[0].id,
        },
      },
    }).then(() => {
      if (country.length > 1) {
        toaster.success("Your information is saved!");
        return refetch();
      }
      toaster.success("Hooray! Your account is setup!");
      refetch();
    });
  };

  const checkUsername = (e) => {
    if (
      e.target.value.match(/^(?!.*\.\.)(?!.*\.$)[^\W][\w.]{0,29}$/) ||
      e.target.value === ""
    ) {
      username.onChange(e);
    }
  };

  return (
    <SetupUsernamePresenter
      onSubmit={onSubmit}
      name={name}
      loading={loading}
      country={country}
      usernameOk={!loading && data && data.users && data.users.length === 0}
      checkUsername={checkUsername}
      username={username}
      isLoading={isLoading}
    />
  );
};
export default SetupUsername;
